import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import Truncate from 'react-truncate'
import { sample } from 'lodash'

import './SearchResultItem.scss'
import Avatar from 'components/Avatar'
import StarRating from 'components/StarRating'
import Price from 'components/Price'

import * as paths from 'utils/paths'

function isNewAliada (aliada) {
  const hasZeroServices = aliada => aliada.finishedServicesCount === 0
  const hasNoReviews = aliada => !hasZeroServices(aliada) && (aliada.ratings.length === 0)
  const needsMoreReviews = aliada => (aliada.ratings.length < 3) && (aliada.averageRating < 4)

  const rules = [hasZeroServices, hasNoReviews, needsMoreReviews]

  const isTrue = x => x === true
  const isNew = rules.map(fn => fn(aliada)).some(isTrue)

  return isNew
}

function hasPositiveComments (aliada) {
  const MINIMUM_RATING_VALUE = 4
  return aliada.ratings.some(rating => rating.value >= MINIMUM_RATING_VALUE)
}

function getLatestPositiveComment (aliada) {
  const MINIMUM_RATING_VALUE = 4
  const FIRST_COMMENT = 0

  const latestPositiveComment = aliada.ratings
                                  .filter(rating => rating.value >= MINIMUM_RATING_VALUE)
                                  .map(rating => rating.comment)[FIRST_COMMENT]

  return `“${latestPositiveComment}”`
}

function getTrustMessage (aliada) {
  const messages = [
    `${aliada.firstName} pasó por los más estrictos filtros para prestar sus servicios en la plataforma.`,
    `Verificamos y resguardamos los datos de ${aliada.firstName} para nunca tengas que preocuparte. `,
    `${aliada.firstName} pasó por exámenes psicométricos, para asegurarnos que sólo personas confiables pertenecen a la comunidad.`,
    `${aliada.firstName}, cómo todas las Aliadas, es calificada por sus clientes para mantener la calidad del servicio.`
  ]

  let message = sample(messages)

  if (process.env.NODE_ENV === 'test') {
    message = messages[0]
  }

  return (
    <span>{message}</span>
  )
}

function ratingSummary (aliada) {
  const cancellationsText = () => {
    const cancellations = aliada.cancellationsCount

    if (cancellations == 1) {
      return '1 cancelación reciente'
    }

    return `${cancellations} cancelaciones recientes`
  }

  return (
    <div>
      <div className='SearchResultItem-info-rating'>
        {isNewAliada(aliada)
          ? newAliada()
          : <StarRating value={aliada.averageRating} min={0} max={5} />
        }
      </div>

      {aliada.finishedServicesCount > 0 &&
        <div className='SearchResultItem-info-servicesCount'>
          {aliada.finishedServicesCount} servicios
        </div>
      }

      { aliada.cancellationsCount > 0 &&
        <div className='SearchResultItem-info-servicesCount'>
          { cancellationsText() }
        </div>
      }
    </div>
  )
}

function newAliada () {
  return (
    <div className='SearchResultItem-newAliada'>
      Aliada nueva
    </div>
  )
}

function SearchResultItem ({ aliada, searchProps, reserveAliada }) {
  const queryobject = {
    estimatedHours: searchProps.estimatedHours,
    serviceTypeId: searchProps.serviceTypeId,
    coordinates: searchProps.coordinates,
    date: searchProps.date,
    time: searchProps.time
  }

  const aliadaProfileUrl = paths.aliadaProfile(aliada.id, queryobject)

  return (
    <div className='SearchResultItem'>
      <div className='SearchResultItem-aliada'>
        <div style={{display: 'flex'}}>
          <Avatar
            image={aliada.profilePicture.original}
            size={60}
            superaliada={aliada.superaliada}
            />

          <div className='SearchResultItem-info'>
            <div className='SearchResultItem-info-name'>
              {aliada.firstName}
            </div>

            {ratingSummary(aliada)}
          </div>
        </div>

        <div className='SearchResultItem-pricing'>
          <p className='SearchResultItem-price'>
            <Price>{aliada.serviceCost}</Price>
          </p>

          <p className='SearchResultItem-estimatedHours'>
            {searchProps.estimatedHours} horas
          </p>
        </div>
      </div>

      <p className='SearchResultItem-review'>
        <Truncate lines={3} ellipsis='…”'>
          {hasPositiveComments(aliada)
            ? getLatestPositiveComment(aliada)
            : getTrustMessage(aliada)
          }
        </Truncate>
      </p>

      <div className='SearchResultItem-buttons'>
        <Link
          className='btn btn-default btn-block btn-lg'
          to={aliadaProfileUrl}
          >
          Ver perfil
        </Link>

        <div className='SearchResultItem-buttonsSpacer' />

        <button
          className='btn btn-primary btn-block btn-lg'
          type='submit'
          onClick={() => reserveAliada(aliada.id)}
          >
          Reservar
        </button>
      </div>
    </div>
  )
}
SearchResultItem.propTypes = {
  aliada: PropTypes.object.isRequired,
  searchProps: PropTypes.shape({
    estimatedHours: PropTypes.number.isRequired,
    serviceTypeId: PropTypes.number.isRequired,
    coordinates: PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired
    }).isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired
  }).isRequired,
  reserveAliada: PropTypes.func.isRequired
}

export default SearchResultItem



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/shared/components/SearchResultItem/SearchResultItem.js